import { isDsV2, isDsV3 } from "./data-rev-helper";

export const StatisticsHelper = {
  getStatLabel(key: string): string {
    const isNewStructures = isDsV2() || isDsV3();
    if (isNewStructures && key === "initiativeCount") key = "projectCount";
    if (isNewStructures && key === "initiativeTotalCount") key = "projectTotalCount";
    if (key === "nationalProjectCount") key = "projectCount";
    if (key === "nationalProjectTotalCount") key = "projectTotalCount";

    switch (key) {
      case "kpiCount":
        return "statistics.kpi_count";
      case "kpiTotalCount":
        return "statistics.kpi_total_count";
      case "initiativeCount":
        return "statistics.initiative_count";
      case "initiativeTotalCount":
        return "statistics.initiative_total_count";
      case "projectCount":
        return "statistics.project_count";
      case "projectTotalCount":
        return "statistics.project_total_count";
      case "serviceCount":
        return "statistics.service_count";
      case "serviceTotalCount":
        return "statistics.service_total_count";
      case "activityCount":
        return "statistics.activity_count";
      case "activityTotalCount":
        return "statistics.activity_total_count";
      case "projectActivityCount":
        return "statistics.project_activity_count";
      case "projectActivityTotalCount":
        return "statistics.project_activity_total_count";
      default:
        return "";
    }
  },
};
